function Home() {
  return (
    <>
      <section className="hero">
        <div className="container hero-grid">
          <div className="hero-text">
            <h1>Building modern web and mobile applications</h1>
            <p>
              We are Sebastian Hellenbrand and Kai Ulrich — friends since
              childhood and co-founders of Ulrich &amp; Hellenbrand GbR. We turn
              ideas into reliable, scalable software. Sebastian is a full‑stack
              engineer focused on the frontend. Kai is a full‑stack engineer
              focused on the backend and automation.
            </p>
            <div className="hero-actions">
              <a
                className="button primary"
                href="mailto:info@present-planner.com"
              >
                Contact us
              </a>
            </div>
          </div>
          <div className="hero-media">
            <img
              src="/kai-sebbi.jpeg"
              alt="Kai Ulrich and Sebastian Hellenbrand"
            />
          </div>
        </div>
      </section>

      <section id="present-planner" className="section present-planner">
        <div className="container">
          <h2>Our Present Planner App</h2>
          <div className="app-preview">
            <div className="app-info">
              <h3>Present Planner: Geschenkideen</h3>
              <p>
                Find gift ideas based on interests in seconds – perfect for
                birthdays, Christmas & more. Never be clueless about gifts
                again. Present Planner shows you interest-based gift ideas that
                really fit – for friends, family, and colleagues.
              </p>
              <div className="app-features">
                <ul>
                  <li>🎁 Plan gifts for all your friends</li>
                  <li>🛍️ Direct product links and recommendations</li>
                  <li>📱 User-friendly mobile app</li>
                  <li>🎯 Personalized suggestions based on interests</li>
                </ul>
              </div>
              <div className="app-actions">
                <a
                  href="https://apps.apple.com/de/app/present-planner-geschenkideen/id6754993286"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="button primary"
                >
                  Download on App Store
                </a>
                <a
                  href="https://play.google.com/store/apps/details?id=com.ulrichwagner.presentplanner"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="button primary"
                >
                  Get it on Google Play
                </a>
              </div>
            </div>
            <div className="app-visual">
              <div className="live-badge">
                <span>✨ Now Available</span>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section id="founders" className="section founders">
        <div className="container">
          <h2>Founders</h2>
          <div className="profiles">
            <article className="profile">
              <img src="/sebbi.png" alt="Sebastian Hellenbrand" />
              <h3>Sebastian Hellenbrand</h3>
              <p>
                Co‑founder. Full‑stack engineer focused on the frontend — UI,
                UX, design systems, and performance.
              </p>
            </article>
            <article className="profile">
              <img src="/kai.jpeg" alt="Kai Ulrich" />
              <h3>Kai Ulrich</h3>
              <p>
                Co‑founder. Full‑stack engineer focused on the backend and
                automation — APIs, infrastructure, and CI/CD.
              </p>
            </article>
          </div>
        </div>
      </section>
    </>
  );
}

export default Home;
